// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"payment-methods_wrapper__WKs8q","title":"payment-methods_title__p3GWu","text":"payment-methods_text__qIreD"};